import React from 'react';
import './Home.css';

const Home = ({ onNavigate }) => {
  const handleClick = (e, pageId) => {
    if (window.innerWidth > 900) {
      e.preventDefault();
      onNavigate(pageId);
    }
  };

  return (
    <div className="home">
      <div className="hero-text">
        <img src="/images/logo-main.png" alt="AG Health Counseling" className="hero-logo" />
        <h1 className="hero-headline">
          Helping clients feel <span className="hero-headline-accent">empowered</span>
          <br />
          to move forward with confidence.
        </h1>
        <p className="hero-sub">
          With over two decades of experience in the helping professions, offering
          thoughtful, personalized care grounded in both clinical expertise and
          real-world understanding.
        </p>
        <a href="#about" className="hero-btn" onClick={(e) => handleClick(e, 'about')}>Learn More</a>
      </div>

      <div className="hero-image-wrap">
        <img
          src="/images/hero-path.png"
          alt="A sunlit forest path opening to a bright view ahead"
        />
      </div>
    </div>
  );
};

export default Home;